import withHttp from '@/config/withHttp';
var baseURL = '/judgeagent';
/* *************** 主页相关 ******************* */

var apis = {
  // 获取服务剩余量
  capacity: {
    url: '/client/capacity',
    method: 'get'
  }
};
export default withHttp(apis, baseURL);